import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-side-bar',
    templateUrl: './common-side-bar.component.html',
    styleUrls: ['./common-side-bar.component.css'],
    standalone: false
})
export class CommonSideBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
